import {
  NewTaskDataModel,
  RealTimeTaskListSort,
  RoomCleanSummary,
  Task,
  TaskAssigneeModel,
  TaskFilter,
} from '@app/core/async-services/http/versioned/task-management/task-management.interface';
import { EntityState } from '@ngrx/entity';
import * as Adapters from './tasks.adapters';
import { Hotel } from '@app/core/models/user.interface';
import { RealtimeRoomsStatus } from '@app/core/async-services/http/versioned/housekeeping/housekeeping.interface';

export interface State {
  isTaskListLoaded: boolean;
  newTaskData?: NewTaskDataModel;
  taskList: EntityState<Task>;
  roomCleanSummary?: RoomCleanSummary;
  isNewTaskDataLoaded: boolean;
  isTaskDetailsLoaded: boolean;
  assignees?: TaskAssigneeModel[];
  realtimeRoomsStatus?: RealtimeRoomsStatus;
  isGetRoomCleanTaskListLoaded: boolean;
  isGetRoomCleanTaskListSuccessful: boolean;
  isGetRealtimeRoomsStatusLoaded: boolean;
  isGetRealtimeRoomsStatusSuccessful: boolean;
  tasksUI: {
    menu: {
      hotel?: Hotel;
      filter?: TaskFilter;
    };
  };
  realtimeRoomsUI: {
    menu: {
      hotel?: Hotel;
    };
  };
  realtimeRoomsTaskListSort?: RealTimeTaskListSort;
  realtimeRoomsView?: 'list' | 'roomAttendant' | 'summary';
}

export const initialState: State = {
  isTaskListLoaded: false,
  taskList: Adapters.taskAdapter.getInitialState(),
  isNewTaskDataLoaded: false,
  isTaskDetailsLoaded: false,
  isGetRoomCleanTaskListLoaded: false,
  isGetRoomCleanTaskListSuccessful: false,
  isGetRealtimeRoomsStatusLoaded: false,
  isGetRealtimeRoomsStatusSuccessful: false,
  tasksUI: {
    menu: {},
  },
  realtimeRoomsUI: {
    menu: {},
  },
  realtimeRoomsTaskListSort: { column: null, orderBy: null },
  realtimeRoomsView: 'list',
};
